<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import * as mi2 from "./utils/mi2";
//引入jsonp请求方法
const jsonp = require("jsonp");
export default {
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    // if (mi2.platform.isApp || mi2.platform.isIOSApp) {
    //   const shareData = {
    //     //web链接分享
    //     h5_v3: {
    //       //微博按钮
    //       //图片比例不限
    //       weibo: {
    //         content: "小米邀你免费抽盲盒",
    //         img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg?kjfkfj",
    //         share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //       },
    //       //微信好友按钮(优先级低于小程序分享)
    //       //图片比例120*120
    //       wechat_friend: {
    //         title: "小米邀你免费抽盲盒",
    //         content: "小米@你，开新年盲盒领隐藏惊喜。",
    //         img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg?kjfkfj",
    //         share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //       },
    //       //微信朋友圈按钮(优先级低于小程序分享)
    //       //图片比例120*120
    //       wechat_moments: {
    //         title: "小米邀你免费抽盲盒",
    //         img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg?kjfkfj",
    //         share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //       },
    //       //qq好友按钮
    //       //图片比例120*120
    //       qq_friend: {
    //         title: "小米邀你免费抽盲盒",
    //         content: "小米@你，开新年盲盒领隐藏惊喜。",
    //         img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg?kjfkfj",
    //         share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //       },
    //       //qq朋友圈按钮
    //       //图片比例120*120
    //       qq_moments: {
    //         title: "小米邀你免费抽盲盒",
    //         content: "小米@你，开新年盲盒领隐藏惊喜。",
    //         img_url: "https://s1.mi.com/m/partner/2021/0113necel/img/role2.jpg?kjfkfj",
    //         share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //       },
    //       //复制链接按钮的网址
    //       share_url: "https://s1.mi.com/m/partner/2021/0113necel/",
    //     },
    //   };
    //   mi2.shareInitApp(shareData);
    // } else {
    //   this.getShareMsg();
    // }
  },
  mounted() {},
  watch: {
    $route: function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  methods: {
    getShareMsg() {
	let newUrl = location.origin + location.pathname
      jsonp(
        `//xmt.www.mi.com/index.php?m=interface-weixin&do=sdk_signature_info&public_id=gh_f10ac97bb079&url=${newUrl}/&type=jsonp`,
        null,
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            if (data.code == 0) {
              wx.config({
                debug: false,
                appId: "wx8388fce6cb5c6eca",
                timestamp: data.data.timestamp,
                nonceStr: data.data.nonce_str,
                signature: data.data.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                ], //选择需要使用的接口如调用拍照或从手机相册中选图接口
              });
              wx.ready(function () {
                wx.updateTimelineShareData({
                  title: "小米@你，开新年盲盒领隐藏惊喜",
                  desc: "小米@你，开新年盲盒领隐藏惊喜。",
                  link: "https://s1.mi.com/m/partner/2021/0113necel/",
                  imgUrl:
                    "https://s1.mi.com/m/partner/2021/0113necel/img/role1.jpg?jdkjkd",
                  success: function () {},
                  cancel: function () {},
                });
                //
                wx.updateAppMessageShareData({
                  title: "小米邀你免费抽盲盒", //25字
                  desc: "小米@你，开新年盲盒领隐藏惊喜。",
                  link: "https://s1.mi.com/m/partner/2021/0113necel/",
                  imgUrl:
                    "https://s1.mi.com/m/partner/2021/0113necel/img/role1.jpg?jdkjkd",
                  success: function () {},
                  cancel: function () {},
                });
              });
            }
          }
        }
      );
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.swiper-pagination .swiper-pagination-bullet {
  display: block;
  float: left;
  margin-left: 0.2rem;
  width: 0.14rem;
  height: 0.14rem;
  border-radius: 50%;
  background: #c7eff2;
}

.swiper-pagination .swiper-pagination-bullet-active {
  background: #28a3ae !important;
}
</style>
